// enci.config.js

/**
 * Configuration object containing API and environment settings.
 * @typedef {Object} Config
 * @property {string} API - The API URL from window.appsettings.api
 * @property {string} ENV - The environment setting from window.appsettings.env, converted to lowercase
 * @property {string} MEDIAWIKI - The MediaWiki base URL
 * @property {string} ENERGYNET - The EnergyNet base URL
 * @property {string} PORTAL - The Portal base URL
 * @property {string} S3 - The S3 base URL
 */
const CONFIG = {
  API: window.appsettings.api,
  ENV: window.appsettings.env.toLowerCase(),
  MEDIAWIKI: window.appsettings.mediawiki,
  ENERGYNET: window.appsettings.energynet,
  PORTAL: window.appsettings.portal,
  S3: window.appsettings.s3,
};

/**
 * Extracts the port from the given URL.
 * @param {string} url - The URL to parse
 * @returns {string} The port from the URL, or the default port (80/443) based on the protocol
 */
const getPortFromUrl = url => {
  try {
    const parsedUrl = new URL(url);
    return parsedUrl.port || (parsedUrl.protocol === 'https:' ? '443' : '80');
  } catch (error) {
    console.error('Invalid URL provided for port extraction:', url, error);
    return null;
  }
};

/**
 * Retrieves the current configuration.
 * @returns {Config} A shallow copy of the current configuration
 */
export const getCurrentConfig = () => ({ ...CONFIG });

/**
 * Retrieves a specific base URL from the configuration.
 * @param {string} key - The key for the desired base URL (e.g., 'API', 'MEDIAWIKI')
 * @returns {string} The requested base URL
 */
export const getBaseUrl = key => CONFIG[key.toUpperCase()];

/**
 * Determines the appropriate API URL based on the current environment.
 * @returns {string} The API URL to be used
 */
export const getApiUrl = () =>
    CONFIG.ENV === 'local'
    ? `https://localhost:${getPortFromUrl(CONFIG.PORTAL)}/api`
    : // TODO: reverify why this was necessary
      'api'; //CONFIG.API.replace(/\/$/, '');

export const getInternalApi = () =>
    CONFIG.ENV === 'local'
    ? `https://localhost:${getPortFromUrl(CONFIG.PORTAL)}/api/v1/internal`
    : // TODO: reverify why this was necessary
      'api/v1/internal'; //CONFIG.API.replace(/\/$/, '');

export const getPublicApi = () =>
    CONFIG.ENV === 'local'
    ? `https://localhost:${getPortFromUrl(CONFIG.PORTAL)}/api/v1/public`
    : // TODO: reverify why this was necessary
      'api/v1/public'; //CONFIG.API.replace(/\/$/, '');